import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';


import Most_View_Ar from './Most_View_Ar.js';





export default function TrendingNews_Main_Ar() {
  const jsonbasket = variables.basename_url + 'updates/index/Athlethixnet_HomeAr_trendingnews.json';

  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();


  async function refda() {

    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    //

    //
    document.getElementById('Main_Dir').dir = "rtl";

    //


    setNisLoading(true);


    Get_Data_TrendingNews_Main_Ar()

  };

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])





  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data_TrendingNews_Main_Ar() {

    JsonArray.splice(0);  //to clear All data in your page

    setNisLoading(true);

    axios.get(jsonbasket)

      .then(function (response) {
        setNisLoading(false);


        for (let i = 0; i < 1 && i < response.data.length; i++) {

          JsonArray.push({

            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split(" ")[0],
            news_imagename: response.data[i].Image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,

          })
        }
      })
  }






  return (
    <>




      <div className="col-md-6">
        <div className="post-news-item-2 col-sm-12">
          {JsonArray.map(Main =>

            <div key={Main.news_title}  >
              <div className="post-news-thumb col-sm-12">

                <a href={Main.link}>
                  <img className='rounded' style={{ maxWidth: '335px', maxHeight: '219px', minWidth: '335px', minHeight: '219px' }} src={Main.news_imagename} alt="gallery" />
                </a>
              </div>
              <div className="post-news-content">
                <h3 className="title1 "><a href={Main.link} >{Main.news_title}</a></h3>
                <a href={Main.link}> <p className='JUUSTIFY A-Color' > {Main.Description.replace(/<[^>]+>/g, '')}</p></a>
                <div className="meta-post-2-style">
                  <div className="meta-post-categores">
                    <a href={Main.link} className='colorForCategory'>{Main.Category}</a>
                  </div>
                  <div className="meta-post-date">
                    <span>{new Date(Main.news_date).toLocaleDateString('ar-EG')}</span>

                  </div>
                </div>
              </div>
            </div>

          )}
        </div>
      </div>
    </>
  );
}



